import { defineMessages } from 'react-intl'

export default defineMessages({
  loading: {
    id: 'SpaceAppBuilder.DataSourceWizard.Loading',
    defaultMessage: 'Loading...'
  },
  saving: {
    id: 'SpaceAppBuilder.DataSourceWizard.Saving',
    defaultMessage: 'Saving...'
  },
  redirecting: {
    id: 'SpaceAppBuilder.DataSourceWizard.redirecting',
    defaultMessage: 'Redirecting to {datasource}...'
  },
  supportLink: {
    id: 'SpaceAppBuilder.DataSourceWizard.supportLink',
    defaultMessage: 'Help'
  },
  title: {
    id: 'SpaceAppBuilder.DataSourceWizard.Title',
    defaultMessage: 'Add a data source'
  },
  searchPlaceholder: {
    id: 'SpaceAppBuilder.DataSourceWizard.SearchPlaceholder',
    defaultMessage: 'Find a data source'
  },
  dataSourcesFound: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourcesFound',
    defaultMessage: 'Data Sources'
  },
  dataSourceBuilder: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourceBuilder',
    defaultMessage: 'Data Source Builder'
  },
  availableDataSources: {
    id: 'SpaceAppBuilder.DataSourceWizard.AvailableDataSources',
    defaultMessage: 'Available'
  },
  featuredDataSources: {
    id: 'SpaceAppBuilder.DataSourceWizard.FeaturedDataSources',
    defaultMessage: 'Featured'
  },
  unavailableDataSources: {
    id: 'SpaceAppBuilder.DataSourceWizard.UnavailableDataSources',
    defaultMessage: 'Currently Unavailable'
  },
  cancel: {
    id: 'SpaceAppBuilder.DataSourceWizard.Cancel',
    defaultMessage: 'Cancel'
  },
  failedAuth: {
    id: 'SpaceAppBuilder.DataSourceWizard.failedAuth',
    defaultMessage: 'Failed to authenticate. Please check your credentials or configuration'
  },
  back: {
    id: 'SpaceAppBuilder.DataSourceWizard.Back',
    defaultMessage: 'Back'
  },
  submit: {
    id: 'SpaceAppBuilder.DataSourceWizard.Submit',
    defaultMessage: 'Connect Data Source'
  },
  update: {
    id: 'SpaceAppBuilder.DataSourceWizard.Update',
    defaultMessage: 'Update Data Source'
  },
  isRequired: {
    id: 'SpaceAppBuilder.DataSourceWizard.IsRequired',
    defaultMessage: 'is required'
  },
  optionalFields: {
    id: 'SpaceAppBuilder.DataSourceWizard.OptionalFields',
    defaultMessage: 'Optional fields'
  },
  viewEndpoints: {
    id: 'SpaceAppBuilder.DataSourceWizard.ViewEndpoints',
    defaultMessage: 'View endpoints'
  },
  configurationDetails: {
    id: 'SpaceAppBuilder.DataSourceWizard.ConfigurationDetails',
    defaultMessage: 'configuration details'
  },
  dataSourceName: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourceName',
    defaultMessage: 'Data source name'
  },
  dataSourceNamePlaceholder: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourceNamePlaceholder',
    defaultMessage: 'Name your data source'
  },
  polling5MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling5MinutesDisplay',
    defaultMessage: 'Every 5 minutes'
  },
  polling10MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling10MinutesDisplay',
    defaultMessage: 'Every 10 minutes'
  },
  polling15MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling15MinutesDisplay',
    defaultMessage: 'Every 15 minutes'
  },
  polling30MinutesDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling30MinutesDisplay',
    defaultMessage: 'Every 30 minutes'
  },
  polling1HourDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling1HourDisplay',
    defaultMessage: 'Every hour'
  },
  polling6HoursDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling6HoursDisplay',
    defaultMessage: 'Every 6 hours'
  },
  polling12HoursDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling12HoursDisplay',
    defaultMessage: 'Every 12 hours'
  },
  polling24HoursDisplay: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling24HoursDisplay',
    defaultMessage: 'Every 24 hours'
  },
  selectPollingInterval: {
    id: 'SpaceAppBuilder.DataSourceWizard.selectPollingInterval',
    defaultMessage: 'Select Polling Interval'
  },
  dataSourceType: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourceType',
    defaultMessage: 'Data Source Type'
  },
  dataSourceEventingDescription: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourceTypeDescription',
    defaultMessage: 'Events are only used in connection with Data Source triggers'
  },
  webhook: {
    id: 'SpaceAppBuilder.DataSourceWizard.Webhook',
    defaultMessage: 'Webhook'
  },
  polling: {
    id: 'SpaceAppBuilder.DataSourceWizard.Polling',
    defaultMessage: 'Polling'
  },
  enableAllEvents: {
    id: 'SpaceAppBuilder.DataSourceWizard.EnableAllEvents',
    defaultMessage: 'Enable all events'
  },
  enableEventsFieldDescription: {
    id: 'SpaceAppBuilder.DataSourceWizard.EnableEventsFieldsDescription',
    defaultMessage: 'Which events would you like to enable for your features?'
  },
  pollingInterval: {
    id: 'SpaceAppBuilder.DataSourceWizard.PollingInterval',
    defaultMessage: 'Polling interval'
  },
  dataSourceUnavailable: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourceUnavailable',
    defaultMessage: 'Request a new data source'
  },
  dataSourceSuggest: {
    id: 'SpaceAppBuilder.DataSourceWizard.DataSourceSuggest',
    defaultMessage: 'Suggest a Data Source'
  },
  monitorEvents: {
    id: 'SpaceAppBuilder.DataSourceWizard.MonitorEvents',
    defaultMessage: 'Monitor Events'
  },
  advanced: {
    id: 'SpaceAppBuilder.DataSourceWizard.advanced',
    defaultMessage: 'Advanced'
  },
  monitorEventsError: {
    id: 'SpaceAppBuilder.DataSourceWizard.MonitorEventsError',
    defaultMessage: 'triggers must be removed from the following features before event monitoring can be disabled:'
  },
  triggerEventsError: {
    id: 'SpaceAppBuilder.DataSourceWizard.TriggerEventsError',
    defaultMessage: 'Existing features are dependent upon the following events which must be enabled:'
  },
  triggerEventsDatasourceConfigurationError: {
    id: 'SpaceAppBuilder.DataSourceWizard.triggerEventsDatasourceConfigurationError',
    defaultMessage: 'Failed to load data source configuration, please reload and try again.'
  },
  datasourceCatalogError: {
    id: 'SpaceAppBuilder.DataSourceWizard.datasourceCatalogError',
    defaultMessage: 'Failed to load data source catalog, please reload and try again.'
  }
})
